import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useTranslation } from 'react-i18next';

type Props = {
  editable: boolean;
  onClose: () => void;
  formId: string;
};

function InfoFooter({ editable, onClose, formId }: Props) {
  const { t } = useTranslation();

  return (
    <Dialog.Footer
      buttonGroupPropsRight={{
        'aria-label': undefined,
        role: 'group',
        children: editable ? (
          [
            <Button prominence="neutral" onClick={onClose} key="cancel">
              {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.CANCEL')}
            </Button>,
            <Button prominence="success" type="submit" form={formId} key="submit">
              {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.SUBMIT')}
            </Button>,
          ]
        ) : (
          <Button prominence="neutral" onClick={onClose}>
            {t('PAGES.MY_GROUPS.MODALS.GROUP_DETAILS.TABS.INFO.FOOTER.ACTIONS.CLOSE')}
          </Button>
        ),
      }}
    />
  );
}

export default InfoFooter;
